import React from 'react';
import classNames from 'classnames';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

interface IProps {
    total: number;
    isActive: boolean;
    selectTab: () => void;
    text: MessageDescriptor;
}

const AttendeeStatusTab = (props: IProps) => {
    const { total, isActive, selectTab, text } = props;
    return (
        <div
            className={classNames('attendees-live-form__status-header', {
                'attendees-live-form__status-active': isActive
            })}
            onClick={selectTab}
        >
            <div className='attendees-live-form__status-count'>{total}</div>
            <div className='attendees-live-form__status-title'>
                <FormattedMessage {...text} />
            </div>
        </div>
    );
};

export { AttendeeStatusTab };